export default __webpack_public_path__ + "static/media/calendar-icon.5d1fef6a.svg";